import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { EvaluationAthleteQuestionProvider } from '../../providers/evaluation-athlete-question-provider.services';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EvaluationAthleteAnswerProvider } from '../../providers/evaluation-athlete-answer-provider.services';
import { HasPendingChangesGuard } from '../../../common/guards/has-pending-changes';
import { ArrayUtils } from "../../../common/providers/array-utils";
import { EvaluationAthlete } from "../../../common/models/evaluation-athlete";
import { Question } from "../../../common/models/question";
import { Answer } from "../../../common/models/answer";
import { NgForOf } from "@angular/common";
import { MatFormField, MatInput, MatInputModule } from "@angular/material/input";
import { FlexLayoutModule } from "@angular/flex-layout";
import { EvaluationAthleteQuestionComponent } from "../question/evaluation-athlete-question";
import { TranslateModule } from "@ngx-translate/core";
import { MatFormFieldModule } from "@angular/material/form-field";

@Component({
  selector: 'evaluation-athlete-question-group',
  providers: [],
  styleUrls: ['./evaluation-athlete-question-group.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgForOf,
    MatInputModule,
    MatFormFieldModule,
    FlexLayoutModule,
    EvaluationAthleteQuestionComponent,
    TranslateModule,
  ],
  templateUrl: './evaluation-athlete-question-group.html'
})
export class EvaluationAthleteQuestionGroupComponent {

    @Input() public user = 'athlete';
    @Input() public evaluationForm: FormGroup = {} as FormGroup;
    @Input() public evaluationAthlete: EvaluationAthlete = {} as EvaluationAthlete;
    @Input() public athleteId: number | undefined;
    @Input() public coachId: number | undefined;
    @Output() public onFormChanged: EventEmitter<any> = new EventEmitter<any>();
    @Input()
    public isDesktop = true;

    public questions: Question[] = [];
    public answers: Answer[] = [];
    public objectKeys = Object.keys;
    public value = 0;

    @HostListener('window:beforeunload')
    doSomething() {
        return !this._changesGuard.hasChanges();
    }

    constructor(
        public conf: ConfigProvider,
        private arrayUtils: ArrayUtils,
        private _changesGuard: HasPendingChangesGuard,
    ) {
    }

    get f() {
        return this.evaluationForm.controls;
    }

    get formQuestionsGrouped() {
        const index = 'questions' + this.arrayUtils.capitalize(this.user);
        const questions = this.evaluationForm.get(index) as FormArray;

        return this.arrayUtils.groupByAttribute(questions.controls, 'value', 'question', 'category', 'id');
    }

    get formQuestions() {
        const index = 'questions' + this.arrayUtils.capitalize(this.user);
        return  this.evaluationForm.get(index) as FormArray;
    }

    public questionEvent(data: any) {
        const event = data[0];
        const formControlName = data[1];

        // find control based on its id
        const formGroup = this.findFormControlById(this.formQuestions.controls, formControlName);

        // then set value
        formGroup.get('answer').setValue(data[2]);

        this.onFormChanged.emit(data);
    }

    private findFormControlById(data: any, key: any) {
        return data.find(function(el: any) {
            return el['value']['id'] === key;
        });
    }
}
